// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__goG+z","noPage":"NotFound_noPage__Wf9F6","linkToHome":"NotFound_linkToHome__4XhNY"};